module.exports = __webpack_public_path__ + "static/media/guilt@3x.dde3eb48.png";